export default function Ornament({ dark = false }) {
  const stroke = dark ? "#C5A059" : "#C5A059";
  return (
    <div className="flex items-center justify-center gap-3 my-4" aria-hidden="true">
      <svg width="90" height="12" viewBox="0 0 90 12" fill="none">
        <path d="M0 6 C 25 6, 30 1, 42 6" stroke={stroke} strokeWidth="0.8" opacity="0.9" />
        <path d="M0 6 C 25 6, 30 11, 42 6" stroke={stroke} strokeWidth="0.8" opacity="0.55" />
      </svg>
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <rect x="3.5" y="3.5" width="7" height="7" transform="rotate(45 7 7)" stroke={stroke} strokeWidth="0.9" />
        <circle cx="7" cy="7" r="1.4" fill={stroke} />
      </svg>
      <svg width="90" height="12" viewBox="0 0 90 12" fill="none" style={{ transform: "scaleX(-1)" }}>
        <path d="M0 6 C 25 6, 30 1, 42 6" stroke={stroke} strokeWidth="0.8" opacity="0.9" />
        <path d="M0 6 C 25 6, 30 11, 42 6" stroke={stroke} strokeWidth="0.8" opacity="0.55" />
      </svg>
    </div>
  );
}
